/**
 * Registry of the Stock movements-tab report columns, mirroring the Coda page "Reports: columns"
 * (41 fields, 15 on by default). Field order here is the canonical order used by the Columns dialog;
 * the default list below is the display order (frozen columns are hoisted to the front by the table).
 */
import {} from './fields.js';
function f(id, group, type, opts = {}) {
    return { id, labelKey: id, group, tab: 'stockMovements', type, ...opts, default: opts.default ?? false };
}
export const STOCK_MOVEMENT_REPORT_FIELDS = [
    // Movement
    f('date', 'movement', 'date', { default: true, sortKey: 'performedAt' }),
    // sorts with its Date sibling (performedAt); a second column cannot reuse the same sort id
    f('time', 'movement', 'name', { default: true }),
    f('movementType', 'movement', 'name', { default: true, sortKey: 'type' }),
    f('quantity', 'movement', 'number', { default: true, cellGroup: 'quantity', decimals: true, sortKey: 'quantity' }),
    f('quantityUnit', 'movement', 'name', { default: true, cellGroup: 'quantity' }),
    f('packages', 'movement', 'number', { default: true, decimals: true, sortKey: 'packages' }),
    f('source', 'movement', 'name', { default: true }),
    f('reason', 'movement', 'name'),
    f('note', 'movement', 'longText'),
    f('user', 'movement', 'name', { default: true }),
    f('storageLocation', 'movement', 'name'),
    // Product
    f('tradeName', 'product', 'name'),
    f('activeSubstance', 'product', 'name'),
    f('strength', 'product', 'name'),
    f('medicineForm', 'product', 'name'),
    f('packSize', 'product', 'number'),
    f('productCode', 'product', 'name'),
    f('manufacturer', 'product', 'name'),
    f('category', 'product', 'name'),
    f('subcategory', 'product', 'name'),
    f('prescriptionTradeName', 'product', 'name'),
    // Batch
    f('batchNumber', 'batch', 'name', { default: true }),
    f('expiry', 'batch', 'date'),
    f('supplier', 'batch', 'name'),
    f('receivedOn', 'batch', 'date'),
    // Linked to
    f('prescriptionNumber', 'linked', 'name', { default: true }),
    f('productionNumber', 'linked', 'name'),
    f('pickingListNumber', 'linked', 'name'),
    f('patientName', 'linked', 'name', { default: true, cellGroup: 'patient' }),
    f('hospitalId', 'linked', 'name', { default: true, cellGroup: 'patient' }),
    f('ward', 'linked', 'name', { default: true }),
    f('section', 'linked', 'name'),
    f('customer', 'linked', 'name'),
    f('responsibleDoctor', 'linked', 'name'),
    f('protocol', 'linked', 'name'),
    f('applicationDate', 'linked', 'date'),
    f('restVialNumber', 'linked', 'name'),
    f('deliveryNoteNumber', 'linked', 'name'),
    // Cost and compliance
    f('unitPrice', 'cost', 'number', { decimals: true }),
    f('value', 'cost', 'number', { decimals: true }),
    // Integration
    f('hospitalSystemOrderNumber', 'integration', 'name'),
];
/** Default shown fields, in display order (the 15 marked Default in the Coda table). */
export const DEFAULT_STOCK_MOVEMENT_FIELD_IDS = [
    'date',
    'time',
    'movementType',
    'quantity',
    'quantityUnit',
    'packages',
    'source',
    'user',
    'tradeName',
    'activeSubstance',
    'batchNumber',
    'prescriptionNumber',
    'patientName',
    'hospitalId',
    'ward',
];
/** Columns pinned to the left while the table scrolls sideways. */
export const STOCK_MOVEMENT_FROZEN_FIELD_IDS = ['date', 'tradeName'];
export const STOCK_MOVEMENT_GROUP_ORDER = [
    'movement',
    'product',
    'batch',
    'linked',
    'cost',
    'integration',
];
export const STOCK_MOVEMENT_FIELD_SET = {
    fields: STOCK_MOVEMENT_REPORT_FIELDS,
    frozenFieldIds: STOCK_MOVEMENT_FROZEN_FIELD_IDS,
    defaultFieldIds: DEFAULT_STOCK_MOVEMENT_FIELD_IDS,
    groupOrder: STOCK_MOVEMENT_GROUP_ORDER,
};
//# sourceMappingURL=stock-movement-fields.js.map